{
  "a11y.dailyPnl": "Pwofi ak pèt chak jou",
  "a11y.dashboard": "Tablodbò",
  "account.changePassword": "Chanje modpas la",
  "account.changePhoto": "Chanje foto",
  "account.confirmPassword": "Konfime nouvo modpas la",
  "account.currentPassword": "Modpas aktyèl",
  "account.emailReverify": "Pwofil la mete ajou. Nou voye yon lyen verifikasyon nan nouvo imèl ou, konfime li pou ou ka kontinye konekte.",
  "account.language": "Lang",
  "account.languageHint": "Chwazi lang pou tout aplikasyon an.",
  "account.memberSince": "Manm depi {date}",
  "account.newPassword": "Nouvo modpas",
  "account.passwordChanged": "Modpas la chanje. Lòt aparèy yo dekonekte.",
  "account.passwordReused": "Nouvo modpas ou dwe diferan de modpas aktyèl la.",
  "account.photoTooLarge": "Imaj sa a twò gwo. Tanpri chwazi youn ki mwens pase 8 MB.",
  "account.photoUnsupported": "Tanpri chwazi yon imaj PNG, JPG, WebP oswa GIF.",
  "account.profile": "Pwofil",
  "account.profileSaved": "Pwofil la mete ajou.",
  "account.removePhoto": "Retire",
  "account.security": "Modpas",
  "account.subtitle": "Jere pwofil ou ak modpas ou.",
  "account.title": "Kont ou",
  "admin.activeSubs": "Abònman aktif",
  "admin.activity": "Aktivite resan",
  "admin.balance": "Balans",
  "admin.byCustomer": "Nèt pa kliyan",
  "admin.capacity": "Kapasite",
  "admin.compReason": "Bay nan Panèl Administrasyon",
  "admin.complimentary": "Gratis",
  "admin.cpuLoad": "Chaj CPU",
  "admin.customers": "Kliyan",
  "admin.dailyPnl": "Pwofi ak pèt chak jou",
  "admin.details": "Detay",
  "admin.equityCurve": "Pwofi kimilatif",
  "admin.fleet": "Tout kliyan",
  "admin.grantComp": "Bay aksè gratis",
  "admin.last14": "14 dènye jou yo",
  "admin.lifetime": "Depi toujou",
  "admin.memory": "Memwa",
  "admin.mrr": "Revni chak mwa",
  "admin.netToday": "Nèt jodi a",
  "admin.noActivity": "Pa gen trade ankò.",
  "admin.noCustomers": "Pa gen kliyan ankò.",
  "admin.overview": "Apèsi",
  "admin.payingStopped": "Ap peye men kanpe",
  "admin.perBotMem": "Memwa pa bòt",
  "admin.price": "Pri",
  "admin.restart": "Rekòmanse",
  "admin.restartsPaused": "Rekòmansman sispann",
  "admin.revokeComp": "Retire aksè gratis",
  "admin.running": "Ap travay",
  "admin.runningUnpaid": "Ap travay san peye",
  "admin.search": "Chèche kliyan",
  "admin.since": "depi",
  "admin.slotsUsed": "{used} sou {max} bòt",
  "admin.step": "Etap",
  "admin.stopped": "Kanpe",
  "admin.suspend": "Sispann",
  "admin.suspended": "Sispann",
  "admin.system": "Sante sèvè a",
  "admin.title": "Administrasyon",
  "admin.trades": "Trade",
  "admin.unreachable": "Pa reponn",
  "admin.unsuspend": "Retabli",
  "admin.uptime": "Tan aktif",
  "admin.winLoss": "Viktwa ak pèt",
  "admin.winRate": "To viktwa",
  "auto.candle": "balèn",
  "auto.candles": "balèn",
  "auto.eligible": "Kalifye",
  "auto.floors": "Yon pè bezwen yon peman {min}% oswa plis pou yo chwazi l, epi {exec}% oswa plis nan moman yo plase komès la.",
  "auto.notProvisioned": "Mòd Otomatik pa aktive sou bot sa a.",
  "auto.off": "Dezaktive",
  "auto.on": "Aktive",
  "auto.payout": "Peman",
  "auto.skipped": "Sote",
  "auto.summaryOff": "Seleksyon pè a dezaktive. Analiz anba a ap kontinye, e lis siyal ou an ap fè komès sou pè li nonmen an.",
  "auto.summaryOn": "Ap analize {total} pè sou fenèt {window} balèn. {eligible} ki kalifye pou fè komès kounye a.",
  "auto.summaryOnOne": "Ap analize 1 pè sou fenèt {window} balèn. {eligible} ki kalifye pou fè komès kounye a.",
  "auto.title": "Mòd Otomatik",
  "auto.trend": "Tandans",
  "auto.trendNone": "pa gen tandans konfime",
  "billing.activating": "Nou resevwa peman an! N ap aktive abònman ou epi mennen ou nan tablodbò a…",
  "billing.active": "Abònman ou aktif.",
  "billing.badgeDue": "An reta",
  "billing.badgeFree": "Gratis",
  "billing.badgeOperator": "Operatè",
  "billing.badgePro": "Pro",
  "billing.badgeTrial": "Esè",
  "billing.canceled": "Abònman ou fini. Abòne ankò pou rekòmanse.",
  "billing.checkoutCancelled": "Peman an anile. Ou ka abòne nenpòt lè.",
  "billing.checkoutSuccess": "Mèsi! N ap aktive abònman ou, sa ka pran kèk segond.",
  "billing.days": "jou",
  "billing.feat1": "Komès otomatik sou kont Pocket Option ou, 24/7",
  "billing.feat2": "Estrateji Martingale, ou ka konfigire etap yo ak miltiplikatè a",
  "billing.feat3": "Limit sekirite pou pèt ak pou pwofi",
  "billing.feat4": "Tablodbò an tan reyèl ak tout istorik trade yo",
  "billing.feat5": "Pwogramasyon siyal ak filtraj peyman OTC",
  "billing.feat6": "Alèt Telegram ak siveyans sante sesyon an",
  "billing.fineprint": "Peman sekirize ak Stripe. Ou ka anile nenpòt lè.",
  "billing.manageCta": "Jere abònman an",
  "billing.month": "mwa",
  "billing.notConfigured": "Abònman yo poko disponib. Tanpri tounen pita.",
  "billing.opening": "Ap ouvri…",
  "billing.pastDue": "Gen yon pwoblèm ak peman ou. Tanpri mete kat ou ajou pou kenbe abònman ou.",
  "billing.planName": "Abònman $mallX",
  "billing.renewsOn": "Li ap renouvle {date}.",
  "billing.startTrialCta": "Kòmanse esè gratis la",
  "billing.subscribeBlurb": "Abòne pou kenbe bòt trading ou ap travay.",
  "billing.subscribeCta": "Abòne",
  "billing.subscribing": "N ap mennen ou nan peman an…",
  "billing.subtitle": "Jere abònman $mallX ou.",
  "billing.tagline": "Tout sa ou bezwen pou otomatize trading ou sou Pocket Option.",
  "billing.title": "Abònman",
  "billing.trialActive": "Esè gratis ou aktif.",
  "billing.trialBanner": "Kòmanse ak yon esè gratis {days} jou, ou p ap peye anyen jodi a.",
  "billing.trialChargeOn": "Premye peman an ap fèt {date}.",
  "billing.trialDaysLeft": "Rete {days} jou nan esè gratis ou",
  "billing.trialFineprint": "Esè gratis {days} jou, apre sa ${price} chak mwa. Anile anvan li fini epi ou p ap peye anyen.",
  "billing.trialFlag": "{days} jou gratis",
  "billing.trialLastDay": "Dènye jou esè gratis ou",
  "billing.trialTagline": "Eseye tout bagay gratis pandan {days} jou, anile anvan li fini epi ou p ap peye anyen.",
  "bot.accountType": "Kont pou fè trade a",
  "bot.connectBlurb": "Mete kont Pocket Option bòt ou dwe itilize pou fè trade.",
  "bot.connectCta": "Konekte kont lan",
  "bot.connected": "Konekte ak {email}.",
  "bot.connectedBlurb": "Bòt ou konekte epi li pare pou fè trade.",
  "bot.connecting": "N ap konekte ak Pocket Option…",
  "bot.connectingCta": "Ap konekte…",
  "bot.createBlurb": "Konfigire pwòp bòt trading pa ou. Li travay pou kont li, ak kont Pocket Option ou.",
  "bot.createCta": "Kreye bòt mwen an",
  "bot.creating": "N ap kreye bòt ou…",
  "bot.demo": "Demo (lajan pratik)",
  "bot.disconnectCta": "Dekonekte kont lan",
  "bot.disconnecting": "Ap dekonekte…",
  "bot.passwordHint": "Li estoke an sekirite sou bòt pa ou sèlman, epi nou p ap janm montre l ankò.",
  "bot.poEmail": "Imèl Pocket Option",
  "bot.poPassword": "Modpas Pocket Option",
  "bot.real": "Reyèl (vrè lajan)",
  "bot.securityNote": "Modpas ou estoke sou pwòp bòt pa ou sèlman, nou pa janm pataje l ni montre l.",
  "bot.subtitle": "Konekte kont Pocket Option ou pou bòt ou ka fè trade pou ou.",
  "bot.title": "Bòt trading ou",
  "bot.verificationTitle": "Pocket Option bezwen verifye koneksyon sa a",
  "bot.verifyBlurb": "Pocket Option vle konfime se yon moun ou ye. Ou ka fè l isit la ou menm — li pran kèk segond.",
  "bot.verifyClickPrompt": "Anba a se paj koneksyon pwòp bòt ou a. Klike sou bwat \"I'm not a robot\" la, apre peze Sign In. Modpas ou deja ranpli e li pa janm parèt isit la.",
  "bot.verifyClosed": "Verifikasyon fèmen. Bòt ou ap redemare.",
  "bot.verifyCta": "Fè verifikasyon an",
  "bot.verifyOpening": "N ap louvri paj koneksyon bòt ou a…",
  "bot.verifyTimeLeft": "Rete {m}:{s}",
  "bot.verifyTimedOut": "Verifikasyon sa a fini. Ou ka rekòmanse l.",
  "bot.verifyTitle": "Fini tchèk Pocket Option an",
  "bot.verifyVerified": "Verifye. Bòt ou ap konekte ankò — paj sa a ap mete l ajou pou kont li.",
  "botset.accountMode": "Kont pou komès",
  "botset.confirmDemo": "Tounen sou kont Demo a?",
  "botset.confirmReal": "Chanje pou kont REYÈL ou? Trade yo ap sèvi ak vre lajan.",
  "botset.confirmResetDay": "Reyinisyalize kontè jodi a yo?",
  "botset.confirmResetLadder": "Reyinisyalize nechèl Martingale la?",
  "botset.connection": "Koneksyon Pocket Option",
  "botset.controls": "Kontwòl",
  "botset.realWarning": "Vre lajan. Tcheke limit pèt ou anvan ou chanje.",
  "botset.resetDay": "Reyinisyalize kontè jounalye yo",
  "botset.resetDaySub": "Efase pwofi, viktwa ak pèt jodi a",
  "botset.resetLadder": "Reyinisyalize nechèl Martingale la",
  "botset.resetLadderSub": "Retounen nan etap 0 epi retire tout kanpe",
  "botset.switchPending": "Gen yon chanjman ki deja ap fèt.",
  "botset.switchPendingHint": "Bot la toujou ap fini yon chanjman anvan. Ou ka voye l ankò si li pa t pase.",
  "botset.switchToDemo": "Chanje pou Demo",
  "botset.switchToReal": "Chanje pou Reyèl",
  "botset.switched": "Kounye a sou kont {mode}.",
  "botset.switching": "Ap chanje, sa ka pran jiska yon minit…",
  "botset.title": "Paramèt bòt la",
  "brand.name": "$mallX",
  "brand.tagline": "Tan Bòt Se Lajan",
  "cel.autoclose": "Fenèt sa a ap fèmen otomatikman nan",
  "cel.cta": "SUPÈ — N A WÈ DEMEN",
  "cel.seconds": "segonn…",
  "cel.stopWin": "Objektif pwofi",
  "cel.subtitle": "rive — nou sekirize sa ou fè jodi a.",
  "cel.titleAccent": "JODI A",
  "cel.titleAfter": "ATEN",
  "cel.titleBefore": "OBJEKTIF",
  "cel.todaysProfit": "PWOFI JODI A",
  "common.back": "Retounen",
  "common.cancel": "Anile",
  "common.close": "Fèmen",
  "common.confirm": "Konfime",
  "common.email": "Imèl",
  "common.genericError": "Gen yon bagay ki pa mache. Tanpri eseye ankò.",
  "common.hidePassword": "Kache",
  "common.loading": "Ap chaje…",
  "common.name": "Non konplè",
  "common.networkError": "Nou pa ka jwenn sèvè a. Tcheke koneksyon ou epi eseye ankò.",
  "common.none": "Okenn",
  "common.password": "Modpas",
  "common.reconnecting": "Ap rekonekte…",
  "common.refresh": "Aktyalize",
  "common.save": "Anrejistre chanjman yo",
  "common.saveChanges": "Anrejistre",
  "common.saving": "Ap anrejistre…",
  "common.showPassword": "Montre",
  "community.blurb": "Antre nan chanèl ak gwoup ofisyèl $mallX sou Telegram.",
  "community.channel": "Chanèl ofisyèl",
  "community.channelSub": "Anons ak mizajou",
  "community.group": "Gwoup kominote a",
  "community.groupSub": "Pale ak lòt tradè $mallX",
  "community.title": "Kominote",
  "dash.acceptingSignals": "Ap aksepte siyal · pare pou fè trade",
  "dash.account": "Kont",
  "dash.balanceDemo": "Balans demo",
  "dash.balanceReal": "Balans kont lan",
  "dash.connected": "Konekte",
  "dash.cycleWL": "Sik G · P",
  "dash.cycles": "Sik",
  "dash.cyclesToday": "Sik Jodi a",
  "dash.demoMode": "Mòd pratik · pa gen vre lajan",
  "dash.equity": "Pwofi ou nan tan",
  "dash.haltActive": "Sekirite a kanpe bot la",
  "dash.halted": "Kanpe",
  "dash.haltedBlurb": "Li kanpe pou jodi a akòz yon limit sekirite.",
  "dash.lastMgStep": "Denye Etap MG",
  "dash.losses": "Pèt",
  "dash.manage": "Jere",
  "dash.netPnl": "Pwofi/Pèt Nèt",
  "dash.nextStake": "Pwochen miz",
  "dash.offline": "Òflayn",
  "dash.paused": "Sispann",
  "dash.pausedBlurb": "Li pa ap fè trade. Peze Kòmanse lè ou pare.",
  "dash.quickStats": "Estatistik rapid",
  "dash.realMode": "Kont reyèl · vre lajan",
  "dash.running": "Ap travay",
  "dash.start": "Kòmanse",
  "dash.step": "Etap Martingale",
  "dash.stop": "Kanpe",
  "dash.title": "Bòt ou",
  "dash.today": "Jodi a",
  "dash.todayNote": "Sa se total pou jounen an nan fizo ore lokal bot la konfigire a — yo remete a zewo a minwi lokal. Okenn done pa janm pedi: dosye konplet ou pou tout tan toujou konseve nan Istwa → Tout.",
  "dash.todayPnl": "Pwofi/Pèt jodi a",
  "dash.tradesToday": "Trade jodi a",
  "dash.winLoss": "Viktwa ak pèt",
  "dash.winRate": "To viktwa sik",
  "dash.wins": "Viktwa",
  "error.already_subscribed": "Ou gentan gen yon abònman. Sèvi ak \"Jere abònman\" pou chanje kat ou oswa plan ou.",
  "error.bot_not_runnable": "Bòt ou pa ka fè trade kounye a.",
  "error.bot_timeout": "Bòt ou pa reponn atan. Si se te yon trade, li ka toujou ap fèt, pa voye l ankò.",
  "error.bot_unreachable": "Bòt ou pa reponn. Li ka nan démaraj.",
  "error.email_not_verified": "Tanpri konfime adrès imèl ou anvan ou konekte. Tcheke bwat imèl ou pou lyen verifikasyon an.",
  "error.email_taken": "Gen yon kont ki egziste deja ak imèl sa a.",
  "error.invalid_credentials": "Imèl oswa modpas la pa kòrèk.",
  "error.invalid_current_password": "Modpas aktyèl la pa kòrèk.",
  "error.invalid_payload": "Tanpri tcheke fòm nan epi eseye ankò.",
  "error.invalid_token": "Lyen sa a pa valid oswa li ekspire.",
  "error.network": "Nou pa ka jwenn sèvè a. Tcheke koneksyon ou epi eseye ankò.",
  "error.no_customer": "Ou poko gen yon kont peman, abòne anvan.",
  "error.no_tenant": "Kreye bòt ou anvan.",
  "error.not_configured": "Abònman yo poko disponib. Tanpri tounen pita.",
  "error.not_found": "Nou pa jwenn kont lan.",
  "error.not_linked": "Konekte kont Pocket Option ou a anvan.",
  "error.password_reused": "Nouvo modpas ou dwe diferan de modpas aktyèl la.",
  "error.rate_limited": "Twòp tantativ. Tanpri eseye ankò nan kèk minit.",
  "error.server_error": "Gen yon pwoblèm sou bò pa nou. Tanpri eseye ankò.",
  "error.slow_down": "Tanpri tann yon ti moman anvan ou eseye ankò.",
  "error.subscription_required": "Ou bezwen yon abònman aktif.",
  "error.tenant_suspended": "Bòt sa a sispann. Tanpri kontakte sipò.",
  "error.unauthorized": "Tanpri konekte pou kontinye.",
  "error.unsupported_expiry": "Pocket Option pa ofri ekspirasyon sa a. Sèvi ak 30s, 1m, 3m, 5m, 30m, 1h oswa 4h.",
  "error.unsupported_timeframe": "Gen liy ki sèvi ak yon tan Pocket Option pa ka plase (M15). Anyen pa t antre nan keu a; gade liy yo anba a.",
  "error.weak_password": "Modpas la dwe gen omwen {min} karaktè.",
  "forgot.backToLogin": "Retounen nan koneksyon",
  "forgot.cta": "Voye lyen an",
  "forgot.sent": "Si gen yon kont pou imèl sa a, yon lyen ap rive. Lyen an ap ekspire nan 1 èdtan.",
  "forgot.subtitle": "Mete imèl ou epi n ap voye yon lyen pou chanje modpas la.",
  "forgot.title": "Reyinisyalize modpas ou",
  "forgot.working": "Ap voye…",
  "history.all": "Tout",
  "history.byLevel": "Rezilta pa nivo Martingale",
  "history.clear": "Efase istorik la",
  "history.confirmClear": "Efase tout istorik trade yo? Sa pa afekte kontè jounalye yo.",
  "history.empty": "Pa gen trade ankò.",
  "history.net": "Nèt",
  "history.noMg": "San MG",
  "history.profit": "Pwofi",
  "history.stake": "miz ${amount}",
  "history.title": "Istorik",
  "history.today": "Jodi a",
  "history.trades": "trade",
  "history.week": "Semèn sa a",
  "history.winRate": "to genyen",
  "history.wins": "genyen",
  "login.checkEmail": "Kont lan kreye. Tcheke imèl ou pou yon lyen verifikasyon, apre sa konekte.",
  "login.cta": "Konekte",
  "login.forgot": "Ou bliye modpas ou?",
  "login.noAccount": "Ou pa gen yon kont?",
  "login.resendVerification": "Voye imèl verifikasyon an ankò",
  "login.resending": "Ap voye…",
  "login.signUp": "Kreye youn",
  "login.subtitle": "Konekte nan kont $mallX ou.",
  "login.title": "Byenveni ankò",
  "login.verificationResent": "Si kont sa a egziste epi li poko verifye, yon nouvo imèl verifikasyon ap rive.",
  "login.working": "N ap konekte ou…",
  "nav.account": "Kont",
  "nav.accountMenu": "Meni kont",
  "nav.admin": "Administrasyon",
  "nav.billing": "Abònman",
  "nav.bot": "Bòt mwen",
  "nav.dashboard": "Tablodbò",
  "nav.history": "Istorik",
  "nav.language": "Lang",
  "nav.settings": "Paramèt",
  "nav.signOut": "Dekonekte",
  "nav.strategy": "Estrateji",
  "nav.trading": "Komès",
  "reason.pausedByUser": "Sispann pa itilizatè a",
  "reason.unknown": "Kanpe",
  "reset.confirmPassword": "Konfime nouvo modpas la",
  "reset.cta": "Chanje modpas la",
  "reset.goToLogin": "Ale nan koneksyon",
  "reset.mismatch": "De modpas yo pa menm.",
  "reset.missingToken": "Lyen sa a pa konplè oswa li ekspire. Tanpri mande yon lòt.",
  "reset.newPassword": "Nouvo modpas",
  "reset.requestNew": "Mande yon nouvo lyen",
  "reset.subtitle": "Mete yon nouvo modpas pou kont ou.",
  "reset.success": "Modpas la chanje. Ou ka konekte kounye a.",
  "reset.title": "Chwazi yon nouvo modpas",
  "reset.working": "Ap chanje…",
  "signup.cta": "Kreye kont",
  "signup.haveAccount": "Ou gen yon kont deja?",
  "signup.passwordHint": "Omwen {min} karaktè.",
  "signup.signIn": "Konekte",
  "signup.subtitle": "Kòmanse otomatize trading ou sou Pocket Option.",
  "signup.title": "Kreye kont ou",
  "signup.working": "N ap kreye kont ou…",
  "status.abandoned": "Abandone",
  "status.cancelled": "Anile",
  "status.completed": "Fini",
  "status.executing": "Ap fèt",
  "status.loss": "Pèdi",
  "status.pending": "Annatant",
  "status.skipped": "Sote",
  "status.tie": "Egalite",
  "status.unknown": "Enkoni",
  "status.win": "Genyen",
  "strategy.baseAmount": "Montan debaz",
  "strategy.enabled": "Aktive",
  "strategy.invalidFields": "Chak chan bezwen yon nimewo (0 oswa plis). Anyen pa t anrejistre.",
  "strategy.martingale": "Martingale",
  "strategy.maxSteps": "Kantite etap maksimòm",
  "strategy.multiplier": "Miltiplikatè",
  "strategy.payout": "Pousantaj peman minimòm",
  "strategy.rateLimit": "Trade pa èdtan, 0 vle di san limit",
  "strategy.safety": "Limit sekirite",
  "strategy.saved": "Anrejistre.",
  "strategy.stopLoss": "Limit pèt chak jou",
  "strategy.stopWin": "Objektif pwofi chak jou",
  "strategy.title": "Estrateji",
  "strategy.zeroOff": "0 vle di limit sa a etenn.",
  "trade.amount": "Montan",
  "trade.asset": "Aktif",
  "trade.batchResult": "{live} nan lis pou tire · {stale} deja pase jodi a · {invalid} pa valab",
  "trade.buy": "Achte",
  "trade.cancelOne": "Anile",
  "trade.clearQueue": "Efase lis la",
  "trade.confirmClearQueue": "Efase lis siyal la? Siyal ki annatant yo ap anile.",
  "trade.direction": "Direksyon",
  "trade.executingNow": "ap egzekite kounye a…",
  "trade.expiry": "Ekspirasyon an segond",
  "trade.firingNow": "ap tire kounye a…",
  "trade.inTime": "nan {t}",
  "trade.lineN": "liy {n}:",
  "trade.place": "Fè trade a",
  "trade.placeSignal": "Fè yon trade",
  "trade.placing": "Trade a ap fèt, sa pran anviwon 70 segond…",
  "trade.queueCounts": "{pending} annatant · {done} fini",
  "trade.queueEmpty": "Pa gen siyal nan lis la.",
  "trade.queueTitle": "Lis siyal",
  "trade.rowEntry": "antre {time} lokal",
  "trade.sell": "Vann",
  "trade.skipPast": "sote — lè sa a te deja pase jodi a",
  "trade.title": "Komès",
  "trade.tzHint": "Lè yo li nan lè lokal aparèy ou a ({tz}). Bot la konvèti an UTC li menm.",
  "trade.upload": "Ajoute nan lis la",
  "trade.uploadHint": "Yon siyal chak liy, pa egzanp EURUSD_OTC-CALL-M1/14:30",
  "trade.uploadTitle": "Ajoute siyal",
  "trade.useMartingale": "Sèvi ak Martingale",
  "validation.email": "Mete yon adrès imèl ki valid.",
  "validation.min": "Li dwe gen omwen {min} karaktè.",
  "validation.required": "Chan sa a obligatwa.",
  "verify.goToLogin": "Ale nan koneksyon",
  "verify.missingToken": "Lyen sa a pa konplè oswa li ekspire. Konekte epi mande yon lòt.",
  "verify.success": "Imèl la verifye. Ou ka konekte kounye a.",
  "verify.title": "Verifye imèl ou",
  "verify.working": "N ap konfime imèl ou…"
}
